export default __webpack_public_path__ + "static/media/RequestAccept.b201865f.svg";